import { hasCommodity } from 'core/domain/CommodityItem'
import { formatDate } from 'core/utils/date'
import { join } from 'core/utils/string'

import { type BaseShipment, type LastLocation } from '../domain/BaseShipment'

export function formatIdentifiers(
  shipment: BaseShipment | BaseShipment['identifiers']
): Array<string> {
  const identifiers = Array.isArray(shipment) ? shipment : shipment.identifiers
  return identifiers.flatMap(({ label, values }) => values.map(value => `${label} #${value}`))
}

export function formatCommodities({ items }: BaseShipment) {
  const hasCommodities = items.some(hasCommodity)
  if (!hasCommodities) return undefined

  const commodities = items.map(({ commodity }) => commodity)

  return join(commodities)
}

export function formatLastLocation(lastLocation: LastLocation) {
  const { city, state, timestamp } = lastLocation

  return `Last update: ${formatDate(timestamp, 'MMM, d')} at ${formatDate(
    timestamp,
    'hh:mm a'
  )} (${city}, ${state})`
}
